<template>
  <div class="container">
    <a-tabs  default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="web端版本更新">
        <android ref="android1"></android>
      </a-tab-pane>
      <a-tab-pane key="2" tab="移动端版本更新">
        <android ref="android2"></android>
      </a-tab-pane>
      <a-tab-pane key="3" tab="小程序版本更新">
        <android ref="android3"></android>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import android from './android.vue'
export default {
  components: {
    android,
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.android1.get_lis(1)
    })
  },
  methods: {
    callback(e) {
      console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
      this.$nextTick(() => {
        if (e == 1) {
          this.$refs.android1.get_lis(1)
        } else if (e == 2) {
          this.$refs.android2.get_lis(2)
        } else if (e == 3) {
          this.$refs.android3.get_lis(3)
        }
      })
    },
  },
}
</script>

<style>
</style>
